export default "__VITE_ASSET__CVCAtx3M__"